import Vue from 'vue';

const videoOverlay = () => {
	let el = document.getElementById('homepage-hero__video');

	new Vue({
		el,
		data: {
			showVideo: false,
			toggled: false,
			classAdded: false,
		},
		computed: {
			videoOverlayClass() {
				return this.classAdded ? 'fade-in' : 'fade-out';
			},
		},
		methods: {
			handleShowVideo() {
				let header = document.getElementById('header');
				let stickyButton = document.querySelector('.sticky-cta');
				let video = document.querySelector('.homepage-hero__video-container');
				// state
				this.showVideo = true;
				this.toggled = false;
				this.classAdded = true;

				// styling
				header.style.zIndex = -1;
				stickyButton.style.zIndex = -1;

				if (video) {
					video.style.animationPlayState = 'running';
				}
			},
			handlePlayVideo(e) {
				let playButton = e.target;
				if(playButton.matches('.play-button-overlay') || playButton.matches('.play-button') || playButton.matches('.play-button__img')) {
					this.toggled = true;
				};
			},
			handleHideVideo(e) {
				let button = e.target;
				let header = document.getElementById('header');
				let stickyButton = document.querySelector('.sticky-cta');
				let video = document.querySelector('.homepage-hero__video-container');
				video.style.animation = 'fadeOut 1s forwards';

				if(button.matches('img') || button.matches('.close-button')) {
					setTimeout(() => {
						this.showVideo = false;
					}, 1000)
					this.classAdded = false;
					this.toggled ? this.toggled : this.toggled = false;


					header.style.zIndex = '';
					stickyButton.style.zIndex = '';
				};



			},
		},
	});

}

export default videoOverlay;


// WEBPACK FOOTER //
// ./scripts/modules/video-overlay.js